import { AxiosPromise } from 'axios';
import { ISignRequest } from './interfaces';

import { vaultApi } from '../api';

const basePath = '/assets/upload/url';

export const checkUpload = <T>(sha1: string): AxiosPromise<any> => vaultApi.getInstance().get(`${basePath}/asset?sha1=${sha1}`);

export const postSignRequest = <T>(params: ISignRequest): AxiosPromise<any> => vaultApi.getInstance().post('/assets/upload/signrequest', params);

export const transcodeAsset = <T>(id: string, needExchangeTranscode: boolean, thumb: boolean, needsVaultTranscode: boolean): AxiosPromise<any> => vaultApi.getInstance().put(`${basePath}/asset/${id}?includeThumb=${thumb ? 'true' : 'false'}&convertTo720=${needExchangeTranscode ? 'true' : 'false'}&isVaultUpload=${needsVaultTranscode ? 'true' : 'false'}`);

export const getUploadUrl = <T>(sha1: string, ext: string): AxiosPromise<any> => vaultApi.getInstance().get(`${basePath}?sha1=${sha1}&ext=${ext}`);

export const setUploadAcl = <T>(url: string): AxiosPromise<any> => vaultApi.getInstance().put(`${basePath}?url=${url}`);

export const pushAsset = <T>(sha1: string, assetid: string, url: string): AxiosPromise<any> => vaultApi.getInstance().post(`${basePath}/asset?sha1=${sha1}&assetid=${assetid}&url=${url}`);

export const getNeedsTranscode = <T>(id: string, isVaultUpload: boolean): AxiosPromise<any> => vaultApi.getInstance().get(`/assets/upload/needstranscode/${id}?isVaultUpload=${isVaultUpload ? 'true' : 'false'}`);
